import { DateTime } from 'luxon'
import { TableHeaderConfigWithType } from '../../components/_EOS/Table'
import { WorkOrderRecall } from './entities/WorkOrderRecall'
import { utcToLocal } from '../../utils/dateHelper'
import { WorkOrderState } from '../../interfaces'
import React from 'react'
import { eTypeStorage } from '../../enums/eTypeStorage'
import { YesNoBadge } from '../../components/YesNoBadge/YesNoBadge'

export const generateTableHeadersWorkOrderRecall = (
  workOrderStates: WorkOrderState[]
) => {
  const tableHeaders: TableHeaderConfigWithType<WorkOrderRecall>[] = [
    {
      field: 'workOrderId',
      title: 'ID',
      sortable: true
    },
    {
      field: 'workOrderStateId',
      title: 'Estado',
      formater: (workOrderStateId: unknown) =>
        workOrderStates?.filter(
          (el) => el.workOrderStateId === (workOrderStateId as number)
        )[0]?.state || 'Sin Estado'
    },
    {
      field: 'createdAt',
      title: 'Fecha de Creación',
      sortable: false,
      formater: (createdAt: unknown) =>
        utcToLocal(createdAt as string, 'dd/MM/yyyy')
    },
    {
      field: 'promiseDate',
      title: 'Fecha Compromiso',
      sortable: false,
      formater: (promiseDate: unknown) => formatNullableDate(promiseDate)
    },
    {
      field: 'withControl',
      title: 'Con Control',
      sortable: false,
      formater: (withControl: unknown) =>
        setIconWithControl(withControl as boolean)
    },
    {
      field: 'typeStorage',
      title: 'Tipo',
      sortable: false,
      formater: (type: unknown) => setType(type as number)
    },
    {
      field: 'productOriginName',
      title: 'Marca',
      sortable: false
    }
  ]

  return tableHeaders
}

const formatNullableDate = (date: DateTime | unknown) => {
  if (date) return utcToLocal(date as string, 'dd/MM/yyyy')
  else return ''
}

const setIconWithControl = (withControl: boolean) => {
  return <YesNoBadge value={withControl} />
}

const setType = (idType: number) => {
  return eTypeStorage[idType] || ''
}
